import React, { PropsWithChildren } from 'react'
import Head from 'next/head'

type Props = {
  title: string
  metatitle?: string
  metadescription?: string | null
}

export const SEO: React.FC<PropsWithChildren<Props>> = ({ title, metatitle, metadescription, children }) => {
  const defaultMetaDescription =
    'Get all the tools you want, for the time you need. Rent tools online and pick them up or get them delivered to yous doorstep.'

  return (
    <Head>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta name="title" content={metatitle || title} />
      <meta property="og:title" content={metatitle || title} />
      <meta name="description" content={metadescription || defaultMetaDescription} />
      <meta property="og:description" content={metadescription || defaultMetaDescription} />
      {children}
    </Head>
  )
}
